import { render } from "./BlockDocument.vue?vue&type=template&id=1d8504aa&scoped=true"
import script from "./BlockDocument.vue?vue&type=script&lang=js"
export * from "./BlockDocument.vue?vue&type=script&lang=js"

import "./BlockDocument.vue?vue&type=style&index=0&id=1d8504aa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8504aa"]])

export default __exports__